import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-3">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-4" />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col animate-in fade-in zoom-in-95 duration-200" data-id="element-5">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-stone-200" data-id="element-6">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-7">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-stone-100 transition-colors text-slate-500 hover:text-slate-700" aria-label="Cerrar" data-id="element-8">
            <X className="w-6 h-6" data-id="element-9" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto text-slate-700 leading-relaxed" data-id="element-10">
          {children}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-stone-200 bg-stone-50 rounded-b-2xl" data-id="element-11">
          <button onClick={onClose} className="w-full py-3 px-6 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors" data-id="element-12">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}